import React, {useEffect, useState} from 'react'
import styled from '@emotion/styled'
//import './prescription-box.css';
import Basic from './FileDropzone.js';
import {addPrescription,getResourceFile} from "../../network";

const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    margin-top: 2rem;

    .header--graphic{
        position:absolute;
        left: 5rem;
        bottom: 8.3rem;
        z-index:-1;
    }
    .header--graphic--second{
        position:absolute;
        justify-self:end;
        right: 2.5rem;
        top: 4rem;
        z-index:-1;
    }
    .header--disclaimer{
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1rem;
    align-self: center;

    padding-left: var(--space-8);
    color: #505962;
    
    grid-row: 9;
    grid-column: 1/span all;
    display: inline-block;
   
    
}

    .header--disclaimer > .advisory{
        font-family: Inter,sans-serif;
        color: var(--company);
        align-self: left;
    }
    @media (max-width: 768px){
        width: 100%;
        /* left: 4.5rem; */

        .header--disclaimer{
            text-align: left;
        }
    }
    @media (max-width: 1100px){

        width: 85vw;
        left: 1rem;
        .header--graphic{
            left: -3rem;
        }
        .header--graphic--second{
            right: -5.5rem;
        }
    
    }
    @media (max-width: 500px){
        /* left: 6.5rem; */
        width: 90vw;
        flex-direction: column;
        justify-content: space-between;
        .header--disclaimer{
            width: 100%;
        }

    }
`;
const PrescriptionWrapper = styled.div`
    display:flex;
    flex-direction:column;
    /* width: 964px; */
    background: #FFFFFF;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.04), 0px 16px 25px rgba(0, 0, 0, 0.06);
    border-radius: var(--space-8);
    padding: var(--space-20);
    align-self: center;

    .prescription-form{
        display: flex;
        flex-direction: row;
        justify-content: space-between;

    .file--upload{
        margin-right: 2rem;
    }
        
    > .file--upload > *{
        background: #F6F8F8;
        color: #7A8590;

        width: 22.63rem;
        height: 6rem;
        border: 1px solid #D8DCDE;
        box-sizing: border-box;
        border-radius: var(--space-8);
        padding: 1.5rem;
        font-size: 1rem;

        font-family: Inter,sans-serif;

        display: flex;
        text-align: center;

}
    }


    @media (max-width: 1100px){
        width: 85vw;
        .prescription-form{
            .file--upload > *{
             width: 17.5rem;
            }
        }
        
    }

@media (max-width: 768px){
    position:relative;
    width: 93vw;
    left: 3.5rem;
    .prescription-form{
        > .file--upload > *{
            width: 14.63rem;
        }
    }
    
   
    .header--disclaimer{
        
    }
}
@media (max-width: 500px){

     left: 0rem;
     padding: 1rem 1rem 1rem 1rem;
     align-items: center;
     box-shadow: none;
    .prescription-form{
        flex-direction: column;
        padding: 1rem 1rem 2rem 1rem;
        justify-content: space-between;
        height: 20rem;
        .file--upload > *{
            width:auto;
        }
    }
 
    .header--disclaimer{
        width:80vw;
    }
    
}
      
`;
const PrescriptionContainer = styled.form`
    display: flex;
    flex-direction: row;
    position:relative;
    justify-content: space-between;


   
    > *{
        display: grid;
        place-items: center;
        justify-items: space-around;
    }
    

    @media (max-width: 768px){
   
        position: relative;
        
    }

    @media (max-width: 500px){
            padding: 1rem 1rem 1rem 0rem;
            align-items:center;
            justify-content:space-between;
            flex-direction:column;
         
    }
 
`;

const TextInput = styled.div`
    z-index: 1;
    font-family: Inter,sans-serif;
    display: inline-block;
    grid-template-areas: 'field-icon''field-area';
    width: auto;
    /* height: var(--space-40); */
    margin-right: 2rem;
    .field-icon{
        
    
        margin-right: var(--space-10);
   
    }
    .field-area{
        min-width: var(--space-20);
        width: auto;
        height: var(--space-40);
    
        background: #F6F8F8;
    
        font-family: Inter,sans-serif;
        font-size: var(--font-16);
        
        border: 1px solid #D8DCDE;
        box-sizing: border-box;
        border-radius: var(--space-4);
    
        padding: 1rem;
    }
    .field-area::placeholder{
        color:var(--color-gray-500);
    }
    /* @media (max-width: 500px){
        .field-area{
            padding-right: 5rem;
        }
    } */
   
`;

const PrescriptionButton = styled.button`
    /* position: static; */

    background: #02B2D9;
    box-shadow: 0px 2px 6px rgba(2, 178, 217, 0.16), 0px 6px 15px rgba(4, 156, 189, 0.24);
    border-radius: 2.75rem;
    color:var(--color-white);
    font-size: 1rem;
    white-space: nowrap;

    height: 1rem;
    align-self: center;
    padding: var(--space-24);

    /* @media (max-width: 768px){

    }
    @media (max-width: 500px){
       margin-top: -3rem;
    } */
`;

const InputContainer = styled.div`
    display:flex;
    flex-direction:row;
`;

function PrescriptionBox() {

    const [name,setName] = useState('');
    const [number,setNumber] = useState('');
    const [prescription,setPrescription] = useState('');

    const sendPrescription = (name,whatsapp_number,type,prescription) =>{
        addPrescription(name,whatsapp_number,type,prescription)
            .then(result => result.send(name,whatsapp_number,type,prescription))
            .catch(error => console.error(error));
        
    }
 
    const getPrescription = (file) => { setPrescription(getResourceFile(file)._id)
    };
    return (
        <MainWrapper>
            <img className="header--graphic" src="/header/display-3-aux/frame-113.svg" alt="dot graphic"/>

            <img className="header--graphic--second" src="/header/display-3-aux/frame-144.svg" alt="dot graphic"/>
            <PrescriptionWrapper>
                <form className="prescription-form">
                    <TextInput>
                        <InputContainer>
                            <img alt="name icon" src="header/display-3-aux/name_icon.svg" className="field-icon" />
                            <input type="text" className="field-area" name="name" placeholder="Name" onChange={(e) => setName(e.target.value.trim())}/>
                        </InputContainer>
                        <br />
                        <InputContainer>
                            <img alt="whatsapp icon" src="/header/display-3-aux/whatsapp_icon.svg" className="field-icon" />
                            <input type="text" className="field-area" name="whatsapp" placeholder="WhatsApp Number" onChange={(e) => setNumber(e.target.value.trim())}/>
                        </InputContainer>
                    </TextInput>
                    <div className="file--upload">
                        <Basic upload={getPrescription}/>
                        {/* <wrappedBasicComponent {...this.fileRef}></wrappedBasicComponent> */}
                    </div>
                    
                    <PrescriptionButton onClick={() => sendPrescription(name, number, 'whatsapp', prescription)} type="submit" className="contact--btn submit">Send My Prescription</PrescriptionButton>
            
                </form>
            </PrescriptionWrapper>

            <p style={{ marginTop: '1.5rem' }} className="header--disclaimer"><span className="advisory">Customer Advisory</span> IRAD assists customers in filling their prescriptions. IRAD is not a Pharmacy.</p>
        </MainWrapper>
    );
    
}
export default PrescriptionBox;